export default {
    categories: {
        product: {
            title: window.i18n.__('Produits'),
            subtitle: window.i18n.__('Données produit'),
        },
    },
    rows: [
        {
            category: 'product',
            label: window.i18n.__('Identifiant Produit'),
            description: {
                text: window.i18n.__('Récupéré depuis un export Sellsy'),
                subtext: window.i18n.__('Utile uniquement en cas de mise à jour'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Référence'),
            description: {
                text: window.i18n.__('Référence ou code du produit unique dans votre catalogue'),
            },
            mandatory: true,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Nom commercial'),
            description: {
                text: window.i18n.__('Nom du produit affiché sur les documents'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Description'),
            description: {
                text: window.i18n.__('Description affichée sur les documents'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Poids'),
            description: {
                text: window.i18n.__('Poids de produit'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique uniquement'),
                subtext: window.i18n.__(
                    'L’unité appliquée sera celle définie dans Réglages > Unités > Paramétrage des unités de mesures > Unité de poids Ex : 90',
                ),
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Unité'),
            description: {
                text: window.i18n.__('Unité de quantification du produit'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__("Valeur de l'unité parmi la liste existante"),
            },
            valueFrom: {
                source: 'units',
                modalName: window.i18n.__('Afficher toutes les unités'),
                maxDisplay: 6,
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Quantité usuelle'),
            description: {
                text: window.i18n.__('Quantité usuelle du produit'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Catégorie'),
            description: {
                text: window.i18n.__('Catégorie du produit'),
                subtext: window.i18n.__('Visibles dans Catalogue > Catégories'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Smart-tags'),
            description: {
                text: window.i18n.__('Liste de smart-tags'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
                subtext: window.i18n.__('À séparer par une virgule'),
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Propriétaire'),
            description: {
                text: window.i18n.__('Propriétaire du produit'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__(
                "Si ce champ n'est pas renseigné alors le nom d’utilisateur qui initie l’import sera ajouté",
            ),
            value: {
                text: window.i18n.__('Nom complet du propriétaire du produit importé'),
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Prix de référence HT'),
            description: {
                text: window.i18n.__('Prix de référence hors taxe du produit'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique (2 décimales)'),
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Taxe'),
            description: {
                text: window.i18n.__('Taux de taxe associé au produit'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Taux de taxe parmi la liste existante'),
            },
            valueFrom: {
                source: 'taxes',
                modalName: window.i18n.__('Afficher toutes les taxes'),
                maxDisplay: 6,
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Prix achat HT'),
            description: {
                text: window.i18n.__("Prix d'achat hors taxe du produit"),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique (2 décimales)'),
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Code comptable vente'),
            description: {
                text: window.i18n.__('Code comptable de vente à associer au produit'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Code comptable parmi la liste existante'),
            },
            valueFrom: {
                source: 'sellAccountingCodes',
                modalName: window.i18n.__('Afficher toutes les valeurs de codes comptables vente'),
                maxDisplay: 3,
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Code comptable achat'),
            description: {
                text: window.i18n.__("Code compte d'achat à associer au produit"),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Code comptable parmi la liste existante'),
            },
            valueFrom: {
                source: 'purchaseAccountingCodes',
                modalName: window.i18n.__('Afficher toutes les valeurs de codes comptables achat'),
                maxDisplay: 3,
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Code barre'),
            description: {
                text: window.i18n.__(
                    'Valeur du code barre, plusieurs valeurs peuvent être générées',
                ),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Valeur du code'),
                subtext: window.i18n.__('À séparer par une virgule'),
            },
        },
        {
            category: 'product',
            label: window.i18n.__('Archivé'),
            description: {
                text: window.i18n.__('Archiver ou non le produit'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('"Y" pour oui ou "N" pour non'),
            },
        },
    ],
};
